import { Pipe, PipeTransform } from '@angular/core';
import { ObjectTypeEnum } from '@shared/model/enum/object-type-enum';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';

@Pipe({
  name: 'textClickable',
  standalone: true
})
export class TextClickablePipe implements PipeTransform {

  transform(verb: ActivityVerbEnum, objectType?: ObjectTypeEnum): boolean {
    let clickable = false;
    if (verb === ActivityVerbEnum.Liked || verb === ActivityVerbEnum.Commented) {
      clickable = this.checkObjectType(objectType!);
    }
    else {
      switch (verb) {
        case ActivityVerbEnum.Posted:
        case ActivityVerbEnum.Reviewed:
        case ActivityVerbEnum.ReadingProgressed:
        case ActivityVerbEnum.StateChangedToRead:
        case ActivityVerbEnum.StateChangedIWantToRead:
        case ActivityVerbEnum.Quoted:
        case ActivityVerbEnum.StateChangedToCurrently:
          clickable = true;
          break;
        case ActivityVerbEnum.ChallengePicked:
          clickable = true;
          break;
        case ActivityVerbEnum.ChallengeObtained:
          clickable = true;
          break;
        case ActivityVerbEnum.AchievementObtained:
          clickable = true;
          break;
        case ActivityVerbEnum.UserReportPublished:
          clickable = true;
          break;
        default:
          clickable = false;
      }
    }
    return clickable;
  }

  checkObjectType(objectType: ObjectTypeEnum): boolean {
    let clickable = false;
    switch (objectType) {
      case ObjectTypeEnum.Post:
        clickable = true;
        break;
      case ObjectTypeEnum.Progress:
        clickable = true;
        break;
      case ObjectTypeEnum.Review:
        clickable = true;
        break;
      case ObjectTypeEnum.Booklist:
        clickable = true;
        break;
      case ObjectTypeEnum.Quote:
        clickable = true;
        break;
      case ObjectTypeEnum.UserReportPublished:
        clickable = true;
        break;
    }

    return clickable;
  }
}
